import AccentButton from '@components/ui/AccentButton';
import { Typography } from '@material-ui/core';
import useLanguageStore from '@stores/languageStore';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const footerLinks = [
  { path: '/services', labelKey: 'navigation.services' },
  { path: '/projects', labelKey: 'navigation.projects' },
  { path: '/gallery', labelKey: 'navigation.gallery' },
  { path: '/about', labelKey: 'navigation.about' },
];

const metaLinks = [
  { path: '/privacy', labelKey: 'footer.privacy' },
  { path: '/terms', labelKey: 'footer.terms' },
  { path: '/accessibility', labelKey: 'footer.accessibility' },
];

const cityLinks = [
  { path: '/cities/holon', labelHe: 'מצבות בחולון', labelEn: 'Tombstones in Holon' },
  { path: '/cities/petah-tikva', labelHe: 'מצבות בפתח תקווה', labelEn: 'Tombstones in Petah Tikva' },
  { path: '/cities/tel-aviv', labelHe: 'מצבות בתל אביב', labelEn: 'Tombstones in Tel Aviv' },
  { path: '/cities/rishon-lezion', labelHe: 'מצבות בראשון לציון', labelEn: 'Tombstones in Rishon LeZion' },
];

const Footer = () => {
  const { t } = useTranslation();
  const { language } = useLanguageStore();
  const isRtl = language === 'he';
  const orderedFooterLinks = isRtl ? footerLinks : [...footerLinks].reverse();
  const orderedMetaLinks = !isRtl ? [...metaLinks].reverse() : metaLinks;

  return (
    <footer
      className={`bg-[#063447] text-white ${isRtl ? 'rtl' : 'ltr'} px-4 sm:px-12 lg:px-28 py-4`}
    >
      <div className="flex flex-col gap-4">
        <div
          className={`flex flex-col gap-6 lg:flex-row lg:items-center ${
            isRtl ? 'text-right' : 'text-left'
          }`}
        >
          <div className="flex flex-col flex-grow gap-2">
            <Typography variant="h6" component="p" className="!font-bold">
              {t('common.appName')}
            </Typography>
            <Typography variant="body2" className="text-white/80">
              {t('footer.tagline')}
            </Typography>
          </div>
          <div className="flex sm:flex-row flex-wrap gap-4 items-center">
            <nav className="flex flex-wrap gap-4 text-sm font-semibold">
              {orderedFooterLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="hover:!text-white/70 !text-white !no-underline"
                >
                  {t(link.labelKey)}
                </Link>
              ))}
            </nav>
            <AccentButton
              to="/contact"
              variant="outlined"
              className="!text-white !border !border-white hover:!bg-white hover:!text-[#063447]"
            >
              {t('common.contactUs')}
            </AccentButton>
          </div>
        </div>
        
        <div className={`flex flex-wrap gap-x-2 gap-y-1 text-sm text-white/60 ${isRtl ? 'text-right' : 'text-left'}`}>
            {cityLinks.map((link, index) => (
              <span key={link.path} className="flex items-center">
                <Link
                  to={link.path}
                  className="hover:!text-white !text-white/60 !no-underline transition-colors"
                >
                  {isRtl ? link.labelHe : link.labelEn}
                </Link>
                {index < cityLinks.length - 1 && <span className="mx-2 hidden sm:inline">|</span>}
              </span>
            ))}
        </div>

        <div
          className={`flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between text-white/80 text-sm ${
            isRtl ? 'text-right' : 'text-left'
          } pt-4 border-t border-white border-solid border-r-0 border-l-0 border-b-0`}
        >
          <Typography variant="body2">{t('footer.address')}</Typography>
          <div className="flex flex-wrap gap-4">
            {orderedMetaLinks.map((link) =>
              link.disabled ? (
                <span key={link.labelKey} className="text-white/40 cursor-not-allowed">
                  {t(link.labelKey)}
                </span>
              ) : (
                <Link
                  key={link.labelKey}
                  to={link.path}
                  className="hover:!text-white !text-white/80 !no-underline"
                >
                  {t(link.labelKey)}
                </Link>
              )
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

